var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemTablet1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_\xED\x95\xAD\xEB\xAA\xA91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.0032 0.0029428C116.394 0.00295004 150.002 33.611 150.002 75.0022L150.002 150.001L75.0032 150.001C33.612 150.001 0.0038859 116.393 0.00389314 75.0022C0.00390037 33.611 33.612 0.00293556 75.0032 0.0029428Z",
    fill: "#E4E1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6118 47.2217C10.5812 47.2217 0.000892639 36.6414 0.000892639 23.6108V-8.39233e-05H23.6118C36.6423 -8.39233e-05 47.2227 10.5802 47.2227 23.6108C47.2227 36.6414 36.6423 47.2217 23.6118 47.2217Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "1_2",
    d: "M23.8628 13.4575L18.7754 16.8491V19.4028L23.7431 16.111H23.8628V33.887H26.4165V13.4575H23.8628Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x95\x84\xEC\x9D\xB4\xEC\xBD\x98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M115.813 57.8296H38.0781V108.29H115.813V57.8296Z",
    fill: "#C3A1F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M116.668 109.145H37.2246V56.9727H116.668V109.145ZM38.9338 107.433H114.959V58.6838H38.9338V107.433Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M114.95 107.434H38.9336V58.6841H114.95V107.434ZM40.6428 105.723H113.241V60.3952H40.6428V105.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M45.3353 56.3887H70.9391C74.2549 56.3887 76.9384 58.981 76.9384 62.1808V106.216C76.9384 103.017 74.2549 100.424 70.9391 100.424H45.3353C45.1985 100.424 45.0703 100.433 44.9336 100.441V56.4143C45.0703 56.4143 45.1985 56.3972 45.3353 56.3972V56.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77.7941 106.216H76.0849C76.0849 103.496 73.7774 101.28 70.9402 101.28H45.3363C45.2509 101.28 45.1654 101.28 45.08 101.288L44.0801 101.348V55.6099L44.8834 55.5586C45.0714 55.5501 45.1996 55.5415 45.3363 55.5415H70.9402C74.7175 55.5415 77.7941 58.5274 77.7941 62.1892V106.225V106.216ZM45.7893 99.5685H70.9402C72.9912 99.5685 74.8286 100.441 76.0849 101.827V62.1892C76.0849 59.4685 73.7774 57.2526 70.9402 57.2526H45.7893V99.5771V99.5685Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M108.557 56.3887H82.9532C79.6373 56.3887 76.9453 58.981 76.9453 62.1808V106.216C76.9453 103.017 79.6373 100.424 82.9532 100.424H108.557C108.694 100.424 108.822 100.433 108.959 100.441V56.4143C108.822 56.4143 108.694 56.3972 108.557 56.3972V56.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M77.801 106.216H76.0918V62.1892C76.0918 58.5188 79.1684 55.5415 82.9542 55.5415H108.558C108.686 55.5415 108.823 55.5415 108.951 55.5586L109.755 55.6099L109.814 56.4142V101.365L108.806 101.305C108.72 101.305 108.644 101.297 108.558 101.297H82.9542C80.117 101.297 77.801 103.513 77.801 106.233V106.216ZM82.9542 57.2441C80.117 57.2441 77.801 59.46 77.801 62.1806V101.827C79.0573 100.441 80.9032 99.5685 82.9542 99.5685H108.105V57.2441H82.9542Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M100.38 64.9243H91.5352V66.6354H100.38V64.9243Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M100.38 74.2236H91.5352V75.9347H100.38V74.2236Z",
    fill: "#8FDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M100.38 83.5151H91.5352V85.2263H100.38V83.5151Z",
    fill: "#8FDAE2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M67.8956 53.7717C65.9385 51.8124 62.7594 51.8124 60.7938 53.7717L59.9649 54.6016L59.1359 53.7717C57.1789 51.8124 53.9998 51.8124 52.0342 53.7717C50.0771 55.7309 50.0771 58.9136 52.0342 60.8814L52.8631 61.7112L59.9649 68.8209L67.0666 61.7112L67.8956 60.8814C69.8526 58.9221 69.8526 55.7394 67.8956 53.7717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M59.9732 70.0292L51.4443 61.4908C49.154 59.1979 49.154 55.4676 51.4443 53.1747C53.7346 50.8819 57.4607 50.8819 59.751 53.1747L59.9732 53.3972L60.1954 53.1747C62.4857 50.8819 66.2118 50.8819 68.5021 53.1747C70.7925 55.4676 70.7925 59.1979 68.5021 61.4908L59.9732 70.0292ZM55.5977 53.1662C54.5294 53.1662 53.4612 53.5769 52.6493 54.3811C51.0256 56.0066 51.0256 58.6503 52.6493 60.2759L59.9732 67.608L67.2971 60.2759C68.9209 58.6503 68.9209 56.0066 67.2971 54.3811C65.6734 52.7555 63.0327 52.7555 61.409 54.3811L59.9818 55.8184L58.5546 54.3811C57.7427 53.5683 56.6745 53.1662 55.6062 53.1662H55.5977Z",
    fill: "#F58B93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M74.1725 48.1484H72.4237C72.0016 48.1484 71.6699 47.8178 71.6699 47.397C71.6699 46.9761 72.0016 46.6455 72.4237 46.6455H74.1725C74.5946 46.6455 74.9263 46.9761 74.9263 47.397C74.9263 47.8178 74.5946 48.1484 74.1725 48.1484Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M79.0104 48.1484H77.2616C76.8395 48.1484 76.5078 47.8178 76.5078 47.397C76.5078 46.9761 76.8395 46.6455 77.2616 46.6455H79.0104C79.4325 46.6455 79.7641 46.9761 79.7641 47.397C79.7641 47.8178 79.4325 48.1484 79.0104 48.1484Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M75.7089 46.6154C75.2867 46.6154 74.9551 46.2847 74.9551 45.8639V44.1206C74.9551 43.6998 75.2867 43.3691 75.7089 43.3691C76.131 43.3691 76.4626 43.6998 76.4626 44.1206V45.8639C76.4626 46.2847 76.131 46.6154 75.7089 46.6154Z",
    fill: "#6AD1EA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M75.7089 51.4372C75.2867 51.4372 74.9551 51.1065 74.9551 50.6857V48.9424C74.9551 48.5216 75.2867 48.1909 75.7089 48.1909C76.131 48.1909 76.4626 48.5216 76.4626 48.9424V50.6857C76.4626 51.1065 76.131 51.4372 75.7089 51.4372Z",
    fill: "#6AD1EA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M56.2904 75.9102H53.7949V77.6213H56.2904V75.9102Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M61.1712 75.9102H58.6758V77.6213H61.1712V75.9102Z",
    fill: "#3C2163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M66.0501 75.9102H63.5547V77.6213H66.0501V75.9102Z",
    fill: "#3C2163"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M62.64 83.5151H53.7949V85.2263H62.64V83.5151Z",
    fill: "#F7D979"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemTablet1);
export default __webpack_public_path__ + "static/media/item_tablet_1.c40117c18b53585def45ceb23826b666.svg";
export { ForwardRef as ReactComponent };